import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const FuelSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="fuel-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
        data-testid="fuel-svg"
      >
        <path
          fill="#070B16"
          d="M18 13.219V5.365c0-.598-.24-1.17-.661-1.593L14.491.925c-.218-.218-.576-.218-.794 0l-.397.397c-.218.218-.218.576 0 .794l1.325 1.326v2.183c0 .988.735 1.803 1.687 1.94v5.654c0 .464-.38.843-.843.843-.464 0-.844-.38-.844-.843v-1.125C14.625 10.385 13.24 9 11.531 9h-.281V2.25C11.25 1.009 10.241 0 9 0H3.375c-1.241 0-2.25 1.009-2.25 2.25v12.375H11.25v-3.938h.281c.777 0 1.406.63 1.406 1.407v.977c0 1.325.95 2.531 2.268 2.668 1.512.152 2.795-1.037 2.795-2.52zM9 6.75H3.375v-4.5H9v4.5zM11.812 18c.31 0 .563-.253.563-.563v-1.125c0-.309-.253-.562-.563-.562H.562c-.309 0-.562.253-.562.562v1.125c0 .31.253.563.562.563h11.25z"
        />
      </svg>
    </StyledContainer>
  );
};

export default FuelSVG;
